/**
 * Neutral holder for the JSON:API model resolver. It exists to break the import cycle between the
 * request engine (resources/mandark.resource) and resources/modelRegistry:
 *
 *   mandark.resource -> modelRegistry -> (every model) -> Generic.model -> mandark.resource
 *
 * mandark.resource imports getModel/getCollectionModel from HERE instead of from modelRegistry, and
 * modelRegistry injects the real implementations via setModelResolver when it loads. This module
 * imports nothing, so it sits safely below both and cannot participate in a cycle. modelRegistry is
 * loaded at app bootstrap (client/main.js) and whenever a query builder is constructed, so the
 * resolver is registered before any request is processed.
 */
type ModelResolver = {
  getModel: (data: unknown) => unknown;
  getCollectionModel: (collectionType: unknown) => unknown;
};

let resolver: ModelResolver | null = null;

export function setModelResolver(modelResolver: ModelResolver): void {
  resolver = modelResolver;
}

function ensureResolver(): ModelResolver {
  if (!resolver) {
    throw new Error(
      'mandark.resource: model resolver not registered — ensure resources/modelRegistry is loaded before issuing requests'
    );
  }
  return resolver;
}

export function getModel(data: unknown): unknown {
  return ensureResolver().getModel(data);
}

export function getCollectionModel(collectionType: unknown): unknown {
  return ensureResolver().getCollectionModel(collectionType);
}
